import _Object$keys from "@babel/runtime-corejs3/core-js-stable/object/keys";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-symbols";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/filter";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor";
import _forEachInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/for-each";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptors";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js-stable/object/define-properties";
import _Object$defineProperty from "@babel/runtime-corejs3/core-js-stable/object/define-property";
import _objectWithoutProperties from "@babel/runtime-corejs3/helpers/objectWithoutProperties";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
var _excluded = ["noRender"];

function ownKeys(object, enumerableOnly) { var keys = _Object$keys(object); if (_Object$getOwnPropertySymbols) { var symbols = _Object$getOwnPropertySymbols(object); if (enumerableOnly) { symbols = _filterInstanceProperty(symbols).call(symbols, function (sym) { return _Object$getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { var _context; _forEachInstanceProperty(_context = ownKeys(Object(source), true)).call(_context, function (key) { _defineProperty(target, key, source[key]); }); } else if (_Object$getOwnPropertyDescriptors) { _Object$defineProperties(target, _Object$getOwnPropertyDescriptors(source)); } else { var _context2; _forEachInstanceProperty(_context2 = ownKeys(Object(source))).call(_context2, function (key) { _Object$defineProperty(target, key, _Object$getOwnPropertyDescriptor(source, key)); }); } } return target; }

import React, { useMemo, memo } from 'react';
import { useStyles, StyleSheet, mq } from '@rexlabs/styling';
import { useMediaQuery } from './hooks/use-media-query';
import { isEqual } from 'lodash';

function CSSBreakpoints(_ref) {
  var children = _ref.children,
      queries = _ref.queries;
  var defaultStyles = useMemo(function () {
    return StyleSheet({
      container: _objectSpread({
        display: 'none'
      }, mq.styles({
        queries: queries,
        styles: {
          display: 'block'
        }
      }))
    });
  }, [queries]);
  var s = useStyles(defaultStyles);
  return /*#__PURE__*/React.createElement("div", s('container'), children);
}

function JavascriptBreakpoints(_ref2) {
  var children = _ref2.children,
      queries = _ref2.queries;
  var matches = useMediaQuery(queries);

  if (matches) {
    return /*#__PURE__*/React.createElement(React.Fragment, null, children);
  }

  return null;
}

function BreakpointsInner(_ref3) {
  var _ref3$noRender = _ref3.noRender,
      noRender = _ref3$noRender === void 0 ? true : _ref3$noRender,
      props = _objectWithoutProperties(_ref3, _excluded);

  if (noRender) {
    return /*#__PURE__*/React.createElement(JavascriptBreakpoints, props);
  }

  return /*#__PURE__*/React.createElement(CSSBreakpoints, props);
}

export var Breakpoints = /*#__PURE__*/memo(BreakpointsInner, isEqual);